import { Converter } from '../types/converter';

export const currencyConverter: Converter = {
  id: 'currency',
  name: 'Currency Converter',
  icon: 'DollarSign',
  categories: ['common'],
  units: []
};
